module.exports = __webpack_public_path__ + "assets/images/scene-3_91e5f00d1e9991c24603665ede2fd557.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-four/croma-abeldo-dialogs/scene-3.png
// module id = 276
// module chunks = 0